/* MUSE & MAKER - THE CREDITED PHOTOGRAPH, behaviour.
   30 Aug 2026. Companion to assets/mm-credit-chips.css and
   snippets/mm-credit-chips.liquid. One file, used by every credited image.

   THE RULES THIS ENFORCES
   - Hover opens on a mouse, tap opens on a finger. Hover does not exist on a
     phone and the private client is on a phone, so touch is not an
     afterthought here: the chip is a real button and a tap toggles it.
   - One card open at a time, anywhere on the page. Two open cards over a
     photograph is a mess, and on a room shot with five fabrics it would be
     unreadable.
   - The photograph underneath is usually a link to the piece. The chips sit
     above it and stop their own clicks, so tapping a chip can never navigate
     away by accident.
   - Which way a card opens is decided in Liquid from the coordinates. This
     file never measures the layout, so nothing reflows and nothing flickers.

   29 SEP 2026 - ON A PHONE THE CARD IS A SHEET. Clara, with a screenshot of
   a fabric card squeezed into a 200px tile: "this doesn't work on mobile ...
   how can we make this look good on mobile". A popover cannot live inside a
   tile that small, so below 750px a tap on a plus moves the REAL card (the
   same node, so its heart and sample pill keep working) into a bottom sheet,
   the same idiom as the piece size sheet ("the tile is the door, the sheet
   is the room", 28 Sep), and moves it back on close. One sheet, built once.
*/
(function () {
  var FINE = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var SHEET = window.matchMedia && window.matchMedia('(max-width:749px)').matches;
  var open = null;

  function close(pt) {
    if (!pt) return;
    pt.classList.remove('is-open');
    var b = pt.querySelector('.mm-cc__chip');
    if (b) b.setAttribute('aria-expanded', 'false');
    if (open === pt) open = null;
  }

  function show(pt) {
    if (open && open !== pt) close(open);
    pt.classList.add('is-open');
    var b = pt.querySelector('.mm-cc__chip');
    if (b) b.setAttribute('aria-expanded', 'true');
    open = pt;
  }

  /* THE SHEET (phones). Built on first use, one for the whole page. */
  var sheet = null, scrim = null, slot = null, sheetFrom = null;
  function buildSheet() {
    scrim = document.createElement('div'); scrim.className = 'mm-cc-scrim';
    sheet = document.createElement('div'); sheet.className = 'mm-cc-sheet';
    sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true');
    sheet.innerHTML = '<div class="mm-cc-sheet__grab"></div><button type="button" class="mm-cc-sheet__close" aria-label="Close">&times;</button><div class="mm-cc-sheet__body"></div>';
    slot = sheet.querySelector('.mm-cc-sheet__body');
    document.body.appendChild(scrim); document.body.appendChild(sheet);
    scrim.addEventListener('click', closeSheet);
    sheet.querySelector('.mm-cc-sheet__close').addEventListener('click', closeSheet);
    sheet.addEventListener('click', function (e) { e.stopPropagation(); });
  }
  function openSheet(pt) {
    if (!sheet) buildSheet();
    if (sheetFrom) closeSheet();
    var pop = pt.querySelector('.mm-cc__pop');
    if (!pop) return;
    sheetFrom = pt;
    slot.appendChild(pop);
    // The card's heart, sample pill and description are hidden at rest on
    // touch and appear on a first tap (mm-fabcard's "peek"). In the sheet the
    // plus WAS the first tap - Clara, 29 Sep: "i don't want people to have to
    // click on the sample again" - so the card opens already peeked. The class
    // is set directly rather than through window.mmPeek, whose 700ms guard
    // would swallow a quick tap on the heart.
    var card = pop.querySelector('.mm-fabcard');
    if (card) card.classList.add('mm-touched');
    pt.classList.add('is-open');
    scrim.classList.add('is-on'); sheet.classList.add('is-on');
    document.documentElement.classList.add('mm-cc-sheet-open');
  }
  function closeSheet() {
    if (!sheetFrom) return;
    var pop = slot.querySelector('.mm-cc__pop');
    if (pop) {
      var card = pop.querySelector('.mm-fabcard');
      if (card) card.classList.remove('mm-touched');
      sheetFrom.appendChild(pop);
    }
    sheetFrom.classList.remove('is-open');
    sheetFrom = null;
    scrim.classList.remove('is-on'); sheet.classList.remove('is-on');
    document.documentElement.classList.remove('mm-cc-sheet-open');
  }

  function init(root) {
    if (root.dataset.mmCcReady) return;
    root.dataset.mmCcReady = '1';

    var points = [].slice.call(root.querySelectorAll('.mm-cc__pt'));

    points.forEach(function (pt, i) {
      // The stagger lives here rather than in the stylesheet so the delay is a
      // function of how many chips this particular photograph has.
      pt.style.transitionDelay = (i * 70) + 'ms';

      var chip = pt.querySelector('.mm-cc__chip');
      if (!chip) return;

      chip.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (SHEET) {
          if (sheetFrom === pt) { closeSheet(); } else { openSheet(pt); }
          return;
        }
        // FOUND BY CLICKING IT, 30 Aug. On a mouse the card is ALREADY open
        // from hover by the time the click lands, so a toggle closed it again
        // and the chip looked broken. Hover and focus own the desktop; the
        // click is the touch path and nothing else.
        if (FINE) return;
        if (pt.classList.contains('is-open')) { close(pt); } else { show(pt); }
      });

      if (FINE && !SHEET) {
        pt.addEventListener('mouseenter', function () { show(pt); });
        pt.addEventListener('mouseleave', function () { close(pt); });
      }

      // Keyboard: the chip is a button, so focus opens it and blur closes it
      // only when focus has genuinely left the card as well as the chip.
      if (!SHEET) {
        chip.addEventListener('focus', function () { show(pt); });
        pt.addEventListener('focusout', function (e) {
          if (!pt.contains(e.relatedTarget)) close(pt);
        });
      }
    });

    // The arrival. Observed rather than scroll-listened, so nothing runs while
    // the image is off screen.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.25 });
      io.observe(root);
    } else {
      root.classList.add('is-in');
    }
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-mm-cc]')).forEach(init);
  }

  document.addEventListener('click', function () { close(open); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(open); closeSheet(); }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  // The theme editor re-renders a section on every settings change, so the
  // component has to re-arm itself or it silently stops working the moment
  // Clara drags a chip. This is the trap that makes a component look broken in
  // Customize while being fine on the live page.
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();